// extracted by mini-css-extract-plugin
export default {"container":"style_container__8ccic","divider":"style_divider__g1KD1","formFooter":"style_formFooter__bY9hf"};